import React from 'react';
import { Radio } from 'rebass';
import styled from 'styled-components';
import { space } from 'styled-system';

const PvDot = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  border: 2px solid ${props => props.color || props.theme.colors.green};
  border-radius: 30px;
  &:after {
    content: '';
    position: absolute;
    display: none;
  }
`;

const PvRadioButtonWrapper = styled.label`
  ${space}
  width: 25px;
  height: 25px;
  display: block;
  position: relative;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  & input {
    top: 0;
    left: 0;
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  ${PvDot}:after {
    left: 10px;
    top: 10px;
    width: 5px;
    height: 5px;
    text-align: center;
    background: #fff;
    border-radius: 5px;
  }
`;

const CustomRadio = styled(Radio)`
  &:hover ~ ${PvDot} {
    background-color: #ccc;
  }
  &:checked ~ ${PvDot} {
    background-color: ${props => props.color || props.theme.colors.green};
    border: none;
  }
  &:checked ~ ${PvDot}:after {
    display: block;
  }`;

export const PvRadioButton = (props) => (
  <PvRadioButtonWrapper mr={props.mr}>
    <CustomRadio name={props.name || 'pvRadioBtn'} {...props} type='radio' />
    <PvDot {...props} />
  </PvRadioButtonWrapper>
);



// WEBPACK FOOTER //
// ./src/components/form/PvRadioButton.jsx